import ZoomAppointment from "../ZoomConference/ZoomAppointment";

export default ZoomAppointment;
